import { useMutation } from "@tanstack/react-query";
import { downloadQuote } from "../QuoteService";
import { showToast } from "../../../../common/Toaster/Toaster";

const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const useDownloadQuote = () =>
  useMutation({
    mutationFn: downloadQuote,
    onSuccess: (blob) => {
      saveBlob(blob, "quote.pdf");
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message || "Error while downloading quote",
        "error"
      );
    },
  });

export default useDownloadQuote;
